// import particlesJS from './particles';

const mainWidth = 644;
const mainHeight = 405;



export default {
    mouseMove: () => {
        // 鼠标移动的效果
        let nextX = 0;
        let nextY = 0;
        $('.banner-base').attr({
            'style': 'transform: rotateX(0deg) rotateY(0deg);'
        });
        $('.banner-base').mousemove((e) => {
            nextX = -(e.offsetX / mainWidth) * 8;
            nextY = ((e.offsetY + 120) / mainHeight) * 10 - 8;
            $('.banner-base').attr({
                'style': `transform: rotateX(${nextX}deg) rotateY(${nextY}deg);`
            })
        });
    },
    backAni: () => {
        // particlesJS('canvas', {
        //     "particles": {
        //         "number": {
        //             "value": 40,
        //             "density": {
        //                 "enable": true,
        //                 "value_area": 1200
        //             }
        //         },
        //         "color": {
        //             "value": "#ddd"
        //         },
        //         "shape": {
        //             "type": "circle",
        //             "stroke": {
        //                 "width": 0,
        //                 "color": "#fff"
        //             },
        //             "polygon": {
        //                 "nb_sides": 5
        //             },
        //             "image": {
        //                 "src": "img/github.svg",
        //                 "width": 100,
        //                 "height": 100
        //             }
        //         },
        //         "opacity": {
        //             "value": 0.5,
        //             "random": false,
        //             "anim": {
        //                 "enable": false,
        //                 "speed": 0.8,
        //                 "opacity_min": 0.1,
        //                 "sync": false
        //             }
        //         },
        //         "size": {
        //             "value": 10,
        //             "random": true,
        //             "anim": {
        //                 "enable": false,
        //                 "speed": 40,
        //                 "size_min": 0.1,
        //                 "sync": false
        //             }
        //         },
        //         "line_linked": {
        //             "enable": true,
        //             "distance": 300,
        //             "color": "#ddd",
        //             "opacity": 0.4,
        //             "width": 1
        //         },
        //         "move": {
        //             "enable": true,
        //             "speed": 2,
        //             "direction": "none",
        //             "random": false,
        //             "straight": false,
        //             "out_mode": "out",
        //             "bounce": false,
        //             "attract": {
        //                 "enable": false,
        //                 "rotateX": 600,
        //                 "rotateY": 1200
        //             }
        //         }
        //     },
        //     "interactivity": {
        //         "detect_on": "canvas",
        //         "events": {
        //             "onhover": {
        //                 "enable": false,
        //                 "mode": "repulse"
        //             },
        //             "onclick": {
        //                 "enable": true,
        //                 "mode": "push"
        //             },
        //             "resize": true
        //         },
        //         "modes": {
        //             "grab": {
        //                 "distance": 400,
        //                 "line_linked": {
        //                     "opacity": 1
        //                 }
        //             },
        //             "bubble": {
        //                 "distance": 600,
        //                 "size": 10,
        //                 "duration": 2,
        //                 "opacity": 0.8,
        //                 "speed": 3
        //             },
        //             "repulse": {
        //                 "distance": 300,
        //                 "duration": 0.4
        //             },
        //             "push": {
        //                 "particles_nb": 2
        //             },
        //             "remove": {
        //                 "particles_nb": 2
        //             }
        //         }
        //     },
        //     "retina_detect": true
        // }, function() {
        // });
    },
    // start: () => {
    //     var lastTime = 0;
    //     var vendors = ['webkit', 'moz'];
    //     for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    //         window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    //         window.cancelAnimationFrame =
    //             window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    //     }

    //     if (!window.requestAnimationFrame)
    //         window.requestAnimationFrame = function(callback, element) {
    //             var currTime = new Date().getTime();
    //             var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    //             var id = window.setTimeout(function() { callback(currTime + timeToCall); },
    //                 timeToCall);
    //             lastTime = currTime + timeToCall;
    //             return id;
    //         };

    //     if (!window.cancelAnimationFrame)
    //         window.cancelAnimationFrame = function(id) {
    //             clearTimeout(id);
    //         };
    //     var canvas = document.getElementById("canvas");
    //     var ctx = canvas.getContext("2d");
    //     var cw = canvas.width = window.innerWidth,
    //         cx = cw / 2;
    //     var ch = canvas.height = window.innerHeight,
    //         cy = ch / 2;

    //     ctx.fillStyle = "#000";
    //     var linesNum = 16;
    //     var linesRy = [];
    //     var requestId = null;

    //     function Line(flag) {
    //         this.flag = flag;
    //         this.a = {};
    //         this.b = {};
    //         if (flag == "v") {
    //             this.a.y = 0;
    //             this.b.y = ch;
    //             this.a.x = randomIntFromInterval(0, ch);
    //             this.b.x = randomIntFromInterval(0, ch);
    //         } else if (flag == "h") {
    //             this.a.x = 0;
    //             this.b.x = cw;
    //             this.a.y = randomIntFromInterval(0, cw);
    //             this.b.y = randomIntFromInterval(0, cw);
    //         }
    //         this.va = randomIntFromInterval(25, 100) / 100;
    //         this.vb = randomIntFromInterval(25, 100) / 100;

    //         this.draw = function() {
    //             ctx.strokeStyle = "rgba(255, 255, 255, .05)";
    //             ctx.beginPath();
    //             ctx.moveTo(this.a.x, this.a.y);
    //             ctx.lineTo(this.b.x, this.b.y);
    //             ctx.stroke();
    //         }

    //         this.update = function() {
    //             if (this.flag == "v") {
    //                 this.a.x += this.va;
    //                 this.b.x += this.vb;
    //             } else if (flag == "h") {
    //                 this.a.y += this.va;
    //                 this.b.y += this.vb;
    //             }

    //             this.edges();
    //         }

    //         this.edges = function() {
    //             if (this.flag == "v") {
    //                 if (this.a.x < 0 || this.a.x > cw) {
    //                     this.va *= -1;
    //                 }
    //                 if (this.b.x < 0 || this.b.x > cw) {
    //                     this.vb *= -1;
    //                 }
    //             } else if (flag == "h") {
    //                 if (this.a.y < 0 || this.a.y > ch) {
    //                     this.va *= -1;
    //                 }
    //                 if (this.b.y < 0 || this.b.y > ch) {
    //                     this.vb *= -1;
    //                 }
    //             }
    //         }

    //     }

    //     for (var i = 0; i < linesNum; i++) {
    //         var flag = i % 2 == 0 ? "h" : "v";
    //         var l = new Line(flag);
    //         linesRy.push(l);
    //     }

    //     function Draw() {
    //         requestId = window.requestAnimationFrame(Draw);
    //         ctx.clearRect(0, 0, cw, ch);

    //         for (var i = 0; i < linesRy.length; i++) {
    //             var l = linesRy[i];
    //             l.draw();
    //             l.update();
    //         }
    //         for (var i = 0; i < linesRy.length; i++) {
    //             var l = linesRy[i];
    //             for (var j = i + 1; j < linesRy.length; j++) {
    //                 var l1 = linesRy[j]
    //                 Intersect2lines(l, l1);
    //             }
    //         }
    //     }

    //     function Init() {
    //         linesRy.length = 0;
    //         for (var i = 0; i < linesNum; i++) {
    //             var flag = i % 2 == 0 ? "h" : "v";
    //             var l = new Line(flag);
    //             linesRy.push(l);
    //         }

    //         if (requestId) {
    //             window.cancelAnimationFrame(requestId);
    //             requestId = null;
    //         }

    //         cw = canvas.width = window.innerWidth,
    //             cx = cw / 2;
    //         ch = canvas.height = window.innerHeight,
    //             cy = ch / 2;

    //         Draw();
    //     };

    //     setTimeout(function() {
    //         Init();

    //         addEventListener('resize', Init, false);
    //     }, 15);

    //     function Intersect2lines(l1, l2) {
    //         var p1 = l1.a,
    //             p2 = l1.b,
    //             p3 = l2.a,
    //             p4 = l2.b;
    //         var denominator = (p4.y - p3.y) * (p2.x - p1.x) - (p4.x - p3.x) * (p2.y - p1.y);
    //         var ua = ((p4.x - p3.x) * (p1.y - p3.y) - (p4.y - p3.y) * (p1.x - p3.x)) / denominator;
    //         var ub = ((p2.x - p1.x) * (p1.y - p3.y) - (p2.y - p1.y) * (p1.x - p3.x)) / denominator;
    //         var x = p1.x + ua * (p2.x - p1.x);
    //         var y = p1.y + ua * (p2.y - p1.y);
    //         if (ua > 0 && ub > 0) {
    //             markPoint({
    //                 x: x,
    //                 y: y
    //             })
    //         }
    //     }

    //     function markPoint(p) {
    //         ctx.beginPath();
    //         ctx.arc(p.x, p.y, 2, 0, 2 * Math.PI);
    //         ctx.fillStyle = "rgba(255,255,255,.1)";
    //         ctx.fill();
    //     }

    //     function randomIntFromInterval(mn, mx) {
    //         return ~~(Math.random() * (mx - mn + 1) + mn);
    //     }
    // }
}



// WEBPACK FOOTER //
// ./src/pages/finance/banner.js